import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsEventType, AnalyticsEventsService } from '@services/analytics-events.service';

@Directive({
  selector: '[vnmAnalyticsEvent], [vnmAnalyticsProps]'
})
export class AnalyticsEventDirective {
  @Input('vnmAnalyticsEvent') type!: AnalyticsEventType;
  @Input('vnmAnalyticsProps') props: object;

  @HostListener('click') click() {
    if (this.type) {
      this.events.trigger(this.type, this.props);
    }
  }

  constructor(private events: AnalyticsEventsService) {}
}
